(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
const track = document.getElementById('testimonial-slider-track');
const wrapper = track.closest('.testimonial-slider-wrapper');
const isDesktop = window.matchMedia('(min-width: 701px)').matches;

if (isDesktop && track.children.length > 0) {
  const originalSlides = Array.from(track.children);
  const totalSlides = originalSlides.length;

  // клони "до" і "після" для безшовного зациклення
  originalSlides.slice().reverse().forEach(s => {
    const clone = s.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.insertBefore(clone, track.firstChild);
  });
  originalSlides.forEach(s => {
    const clone = s.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  let currentIndex = totalSlides; // старт на першому реальному слайді
  let slideWidth = 0;

  // ховаємо трек, поки не порахували стартову позицію (щоб не блимнуло не тим слайдом)
  track.style.visibility = 'hidden';

  function recalcWidth() {
    slideWidth = track.children[0].getBoundingClientRect().width;
    setPosition(false);
    track.style.visibility = 'visible';
  }

  function setPosition(animate = true) {
    track.style.transition = animate ? 'transform 0.5s ease-in-out' : 'none';
    track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
  }

  function goTo(index) {
    currentIndex = index;
    setPosition(true);
  }

  track.addEventListener('transitionend', () => {
    if (currentIndex >= totalSlides * 2) {
      currentIndex -= totalSlides;
      setPosition(false);
    } else if (currentIndex < totalSlides) {
      currentIndex += totalSlides;
      setPosition(false);
    }
  });

  recalcWidth();
  window.addEventListener('resize', recalcWidth);

  const prevBtn = document.getElementById('prevSlide');
  const nextBtn = document.getElementById('nextSlide');
  if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
} else {
  track.style.visibility = 'visible';
}

  } catch(e) { console.error(e); }
})();
})();
